var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatDisconnectedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_160810",
    "data-name": "Group 160810",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250.788,
    height: 186.892,
    viewBox: "0 0 250.788 186.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2117",
    "data-name": "Rectangle 2117",
    width: 250.788,
    height: 186.892,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2098",
    "data-name": "Rectangle 2098",
    width: 8.116,
    height: 12.8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2099",
    "data-name": "Rectangle 2099",
    width: 3.854,
    height: 5.416,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2100",
    "data-name": "Rectangle 2100",
    width: 3.401,
    height: 18.408,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2101",
    "data-name": "Rectangle 2101",
    width: 5.788,
    height: 6.345,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2102",
    "data-name": "Rectangle 2102",
    width: 22.568,
    height: 28.237,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2103",
    "data-name": "Rectangle 2103",
    width: 2.808,
    height: 8.101,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2104",
    "data-name": "Rectangle 2104",
    width: 4.475,
    height: 4.866,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2105",
    "data-name": "Rectangle 2105",
    width: 20.003,
    height: 23.003,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2107",
    "data-name": "Rectangle 2107",
    width: 9.261,
    height: 13.086,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2109",
    "data-name": "Rectangle 2109",
    width: 6.923,
    height: 7.005,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2110",
    "data-name": "Rectangle 2110",
    width: 5.807,
    height: 19.181,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2111",
    "data-name": "Rectangle 2111",
    width: 6.255,
    height: 5.068,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2112",
    "data-name": "Rectangle 2112",
    width: 6.079,
    height: 12.445,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2113",
    "data-name": "Rectangle 2113",
    width: 5.748,
    height: 5.022,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2114",
    "data-name": "Rectangle 2114",
    width: 25.668,
    height: 25.668,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2115",
    "data-name": "Rectangle 2115",
    width: 17.804,
    height: 17.804,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160809",
    "data-name": "Group 160809",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2089",
    "data-name": "Rectangle 2089",
    width: 250.788,
    height: 0.125,
    transform: "translate(0 164.239)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160754",
    "data-name": "Group 160754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160753",
    "data-name": "Group 160753",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M137.924,141.87H41.07a2.866,2.866,0,0,1-2.863-2.863V2.863A2.867,2.867,0,0,1,41.07,0h96.854a2.866,2.866,0,0,1,2.862,2.863V139.007a2.866,2.866,0,0,1-2.862,2.863M41.07.125a2.74,2.74,0,0,0-2.738,2.738V139.007a2.74,2.74,0,0,0,2.738,2.738h96.854a2.741,2.741,0,0,0,2.737-2.738V2.863A2.741,2.741,0,0,0,137.924.125Z",
    transform: "translate(-19.043)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M354.221,141.87H257.368a2.866,2.866,0,0,1-2.862-2.863V2.863A2.866,2.866,0,0,1,257.368,0h96.854a2.866,2.866,0,0,1,2.863,2.863V139.007a2.866,2.866,0,0,1-2.863,2.863M257.368.125a2.74,2.74,0,0,0-2.737,2.738V139.007a2.74,2.74,0,0,0,2.737,2.738h96.854a2.741,2.741,0,0,0,2.738-2.738V2.863A2.741,2.741,0,0,0,354.221.125Z",
    transform: "translate(-126.851)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2090",
    "data-name": "Rectangle 2090",
    width: 15.834,
    height: 0.125,
    transform: "translate(209.826 169.016)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2091",
    "data-name": "Rectangle 2091",
    width: 16.757,
    height: 0.125,
    transform: "translate(151.439 167.655)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2092",
    "data-name": "Rectangle 2092",
    width: 31.315,
    height: 0.125,
    transform: "translate(198.918 173.674)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2093",
    "data-name": "Rectangle 2093",
    width: 9.647,
    height: 0.125,
    transform: "translate(26.312 172.831)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2094",
    "data-name": "Rectangle 2094",
    width: 15.194,
    height: 0.125,
    transform: "translate(40.426 172.831)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2095",
    "data-name": "Rectangle 2095",
    width: 27.364,
    height: 0.125,
    transform: "translate(95.088 170.713)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160756",
    "data-name": "Group 160756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160755",
    "data-name": "Group 160755",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M250.611,355.642c0,3.137-43.54,5.679-97.25,5.679s-97.25-2.543-97.25-5.679,43.54-5.679,97.25-5.679,97.25,2.543,97.25,5.679",
    transform: "translate(-27.967 -174.43)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160785",
    "data-name": "Group 160785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160784",
    "data-name": "Group 160784",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M148.049,86.155c-4.043,4.064,2.83,10.381-1.711,13.278,3.7,1.863,16.7,4.225,20.044-3.091-2.452-1.905-.749-6.594-3.013-11.09-3.361-6.674-19.363-3.72-15.32.9",
    transform: "translate(-72.938 -40.546)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M147.006,90.7c-1.261-.212-5.511,1.907-2.349,7.59,2.554,4.591.427,4.919.427,4.919s2.522.071,1.018-3.345c-1.608-3.647-2.358-7.431.9-9.165",
    transform: "translate(-71.529 -45.202)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M192.656,146.938A1.225,1.225,0,0,0,191,146.42l-.3.156c-.093.049-.275.17-.422.251s-.311.181-.472.262a7.941,7.941,0,0,1-.981.414,6.154,6.154,0,0,1-1.929.363,5.232,5.232,0,0,1-1.78-.286,6.479,6.479,0,0,1-1.052-.49c-.43-.954-.84-1.917-1.194-2.909-.426-1.161-.8-2.345-1.13-3.544s-.622-2.409-.864-3.628c-.125-.608-.237-1.218-.336-1.827l-.134-.908c-.046-.292-.086-.619-.113-.85l-.012-.1a2.507,2.507,0,0,0-4.989.5c.034.423.066.75.11,1.109s.1.7.147,1.044q.166,1.034.373,2.053a39.731,39.731,0,0,0,1.053,4.022c.2.664.44,1.317.666,1.973.259.647.5,1.3.783,1.936a37.205,37.205,0,0,0,1.862,3.755l.062.111a1.941,1.941,0,0,0,.777.773,10.17,10.17,0,0,0,3.036,1.075,8.488,8.488,0,0,0,3.288-.072,8.7,8.7,0,0,0,2.885-1.254,9.327,9.327,0,0,0,1.175-.946c.182-.171.357-.347.526-.532s.307-.364.505-.624a1.227,1.227,0,0,0,.108-1.306",
    transform: "translate(-87.369 -65.35)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M211.5,153.3l-.144,0a3.122,3.122,0,0,0-2.516,1.176l-2.422,3.039-.021,2.078c1.944.772,4.414-1.312,4.414-1.312l1.248-.312a1.747,1.747,0,0,0,1.306-1.946l-.177-1.222a1.747,1.747,0,0,0-1.688-1.5",
    transform: "translate(-102.875 -76.404)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M178.8,128.984c1.62,1.664,1.723,6.637,1.723,6.637l-6.484,5.214s-2.659-7.369-1.188-9.973c1.249-2.21,3.885-4,5.949-1.878",
    transform: "translate(-85.933 -63.816)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160759",
    "data-name": "Group 160759",
    transform: "translate(86.476 64.219)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160758",
    "data-name": "Group 160758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160757",
    "data-name": "Group 160757",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M178.8,128.984c1.62,1.664,1.723,6.637,1.723,6.637l-6.484,5.214s-2.659-7.369-1.188-9.973c1.249-2.21,3.885-4,5.949-1.878",
    transform: "translate(-172.409 -128.035)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M163.779,343.042l3.579.4.491-9.733-3.579-.395Z",
    transform: "translate(-81.631 -166.129)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M167.294,348.833h-4.209a.324.324,0,0,0-.335.306l-.28,3.98a.79.79,0,0,0,.776.8c1.776.016,1.793.008,4.006.008h5.973c1.838,0,1.843-1.859,1.048-2.027a12.863,12.863,0,0,1-6.21-2.789,1.252,1.252,0,0,0-.769-.275",
    transform: "translate(-80.978 -173.866)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160762",
    "data-name": "Group 160762",
    transform: "translate(82.363 167.183)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160761",
    "data-name": "Group 160761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160760",
    "data-name": "Group 160760",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M168.063,333.71l-.252,5.017-3.6,0,.272-5.417Z",
    transform: "translate(-164.209 -333.314)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M163.316,177.721s3.095,25.948,3.095,37.484c-2.442,16.05-4.507,44.218-4.507,44.218l-4.959-.127s-2.252-30.68-.163-43.923c-2.675-11.871-5.976-39.255-5.976-39.255Z",
    transform: "translate(-75.165 -87.781)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160765",
    "data-name": "Group 160765",
    transform: "translate(76.882 97.164)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160764",
    "data-name": "Group 160764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160763",
    "data-name": "Group 160763",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M155,193.718a14.8,14.8,0,0,0-1.715.893c.682,5.121,1.58,11.566,2.533,17.515,1.625-4.9.747-15.659-.818-18.408",
    transform: "translate(-153.281 -193.718)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M86.46,326.45l2.952,2.062,5.1-8.307-2.952-2.062Z",
    transform: "translate(-43.094 -158.57)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M87.238,333.155l-2.516-3.375a.324.324,0,0,0-.445-.085l-3.359,2.154a.791.791,0,0,0-.175,1.1c1.049,1.433,1.065,1.443,2.388,3.216l3.571,4.788c1.1,1.474,2.592.367,2.251-.372a12.867,12.867,0,0,1-1.477-6.645,1.251,1.251,0,0,0-.239-.781",
    transform: "translate(-40.171 -164.301)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160768",
    "data-name": "Group 160768",
    transform: "translate(45.623 159.574)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160767",
    "data-name": "Group 160767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160766",
    "data-name": "Group 160766",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M96.748,320.208l-2.626,4.282-3.162-1.722,2.835-4.623Z",
    transform: "translate(-90.96 -318.145)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M114.649,284.943c-2.564,0-7.9,0-7.991-3.772-.071-2.961,3.591-4.187,6.749-4.338a2.664,2.664,0,0,1,2.793,2.538c0,.067,0,.133,0,.2,3.58-.17,5.9-.952,6.745-2.287,1.912-3.014-1.748-10.78-5.287-18.291-4.161-8.831-8.876-18.839-8.969-28.422a2.669,2.669,0,0,1,2.643-2.694h.026a2.669,2.669,0,0,1,2.668,2.642c.081,8.416,4.532,17.864,8.46,26.2,4.533,9.622,8.449,17.932,4.965,23.424-2.049,3.231-6.238,4.8-12.805,4.8",
    transform: "translate(-53.16 -113.579)",
    fill: "#dd0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M129.526,176.629s-8.556,29.652-12.737,40.4c-8.092,14.075-21.525,35.619-21.525,35.619l-4.291-2.488s10.035-24.878,16.781-36.464c1.809-12.033,8.656-38.753,8.656-38.753Z",
    transform: "translate(-45.344 -87.198)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M94.661,340.078a1.451,1.451,0,0,0,.747.608.509.509,0,0,0,.481-.164.371.371,0,0,0,.11-.309c-.063-.6-1.616-1.382-1.926-1.532a.083.083,0,0,0-.1.032.132.132,0,0,0-.012.129,7.238,7.238,0,0,0,.7,1.236m1.069-.019a.41.41,0,0,1,.089.191.118.118,0,0,1-.042.1.348.348,0,0,1-.333.114c-.328-.066-.764-.6-1.189-1.45a5.255,5.255,0,0,1,1.475,1.042",
    transform: "translate(-46.825 -168.803)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M93.969,338.324a.087.087,0,0,0,.028.025c.5.278,1.806.5,2.09.084a.422.422,0,0,0-.025-.478c-.518-.893-2,.152-2.068.2a.123.123,0,0,0-.047.1.116.116,0,0,0,.023.07m1.9-.293a.564.564,0,0,1,.038.057c.055.094.067.164.038.206-.165.24-1.131.158-1.692-.064.377-.228,1.256-.682,1.617-.2",
    transform: "translate(-46.825 -168.266)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M175.373,349.432a1.454,1.454,0,0,0,.934-.235.509.509,0,0,0,.156-.484.369.369,0,0,0-.182-.273c-.52-.308-2.074.469-2.379.628a.082.082,0,0,0-.037.1.132.132,0,0,0,.1.087,7.232,7.232,0,0,0,1.412.175m.624-.868a.408.408,0,0,1,.206.043.117.117,0,0,1,.058.1.348.348,0,0,1-.107.335,2.68,2.68,0,0,1-1.873.087,5.252,5.252,0,0,1,1.717-.559",
    transform: "translate(-86.656 -173.635)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M173.983,348.254a.089.089,0,0,0,.037-.007c.521-.232,1.478-1.15,1.317-1.625a.422.422,0,0,0-.4-.266c-1.025-.118-1.076,1.7-1.078,1.775a.124.124,0,0,0,.053.1.121.121,0,0,0,.07.024m.9-1.7a.664.664,0,0,1,.069,0c.108.013.171.044.188.093.094.275-.549,1-1.063,1.319.042-.439.2-1.415.807-1.415",
    transform: "translate(-86.656 -172.629)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M141.688,149.062c3.3.423,10.306,1.319,17.082,2.188,3.856-12.972,5.121-19.235,5.465-22.253a3.285,3.285,0,0,0-2.269-3.515c-1.021-.322-2.294-.7-3.579-1.03-.439-.113-.883-.22-1.32-.316a54.751,54.751,0,0,0-7.756-1c-.386-.033-.769-.054-1.152-.075-.757-.036-1.5-.05-2.187-.05a3.686,3.686,0,0,0-3.675,4.012c.132,1.516.239,2.9.32,4.187.191,3,.249,5.419.206,7.527a65,65,0,0,1-1.134,10.323",
    transform: "translate(-70.621 -61.313)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160771",
    "data-name": "Group 160771",
    transform: "translate(71.067 61.7)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160770",
    "data-name": "Group 160770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160769",
    "data-name": "Group 160769",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M141.688,149.062c3.3.423,10.306,1.319,17.082,2.188,3.856-12.972,5.121-19.235,5.465-22.253a3.285,3.285,0,0,0-2.269-3.515c-1.021-.322-2.294-.7-3.579-1.03-.439-.113-.883-.22-1.32-.316a54.751,54.751,0,0,0-7.756-1c-.386-.033-.769-.054-1.152-.075-.757-.036-1.5-.05-2.187-.05a3.686,3.686,0,0,0-3.675,4.012c.132,1.516.239,2.9.32,4.187.191,3,.249,5.419.206,7.527a65,65,0,0,1-1.134,10.323",
    transform: "translate(-141.688 -123.013)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160774",
    "data-name": "Group 160774",
    transform: "translate(71.995 69.325)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160773",
    "data-name": "Group 160773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160772",
    "data-name": "Group 160772",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M143.744,146.315c2.258-2.918,3.072-6.257,2.342-8.1l-2.548.573c.192,3,.25,5.419.206,7.528",
    transform: "translate(-143.538 -138.214)",
    fill: "#407bff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M164.155,124.476c-.441-.115-.883-.221-1.319-.321a55.5,55.5,0,0,0-7.759-1c-.386-.03-.767-.05-1.149-.07l-.667-.03.527.878a22.067,22.067,0,0,0,6.039,5.909l.908.632.873-.667a6.592,6.592,0,0,0,2.749-5.282c-.065-.015-.135-.035-.2-.05",
    transform: "translate(-76.389 -61.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M158.762,111.689c-.16,2.111-.657,4.262-1.882,5.164a20.67,20.67,0,0,0,5.618,5.45,4.962,4.962,0,0,0,2.139-4.456c-2.7-1.021-2.514-2.874-1.369-5.857l-2.106-1.134a1.381,1.381,0,0,0-2.4.833",
    transform: "translate(-78.193 -55.026)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160777",
    "data-name": "Group 160777",
    transform: "translate(80.598 55.374)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160776",
    "data-name": "Group 160776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160775",
    "data-name": "Group 160775",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M163.058,110.854a1.379,1.379,0,0,0-2.369.642,8.518,8.518,0,0,0,3.684,3.769,9.156,9.156,0,0,1,.791-3.277Z",
    transform: "translate(-160.689 -110.4)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M153.911,92.578c1.047,4.077,1.4,5.824,3.894,7.541,3.747,2.582,8.525.4,8.717-3.9.173-3.877-1.568-9.892-5.922-10.757a5.74,5.74,0,0,0-6.689,7.118",
    transform: "translate(-76.619 -42.536)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M162.933,85.65a22,22,0,0,1-8.509,4.7s3.111,6.625-2.717,4.953c-1.689-5.643.024-8.568,1.487-9.948,4.64-1.5,7.9-2.006,9.74.292",
    transform: "translate(-75.265 -41.906)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M153.56,105.752a3.075,3.075,0,0,0,1.726,1.593c1.015.365,1.6-.524,1.384-1.522-.2-.9-.958-2.172-2.008-2.107a1.382,1.382,0,0,0-1.1,2.036",
    transform: "translate(-76.465 -51.693)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M140.452,172.787l-.967,1.431c-.075.111.05.25.248.275l17.916,2.3c.154.02.291-.04.313-.135l.35-1.509c.024-.1-.1-.212-.266-.233l-17.3-2.218a.312.312,0,0,0-.294.093",
    transform: "translate(-69.512 -86.073)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M144.968,175.119l-.463-.059c-.092-.012-.156-.069-.142-.126l.472-1.959c.014-.057.1-.094.193-.082l.463.059c.092.012.156.068.143.126l-.472,1.959c-.014.057-.1.095-.193.083",
    transform: "translate(-71.952 -86.173)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M172.477,178.647l-.463-.059c-.092-.012-.157-.069-.142-.126l.472-1.959c.014-.058.1-.095.193-.083l.463.059c.092.012.157.068.143.126l-.472,1.959c-.014.057-.1.095-.193.083",
    transform: "translate(-85.664 -87.931)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M158.723,176.883l-.464-.059c-.092-.012-.156-.069-.142-.126l.472-1.959c.014-.057.1-.094.194-.082l.462.059c.092.012.157.068.143.126l-.472,1.959c-.013.057-.1.095-.192.083",
    transform: "translate(-78.808 -87.052)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M168.005,98.736c.065.336.295.574.515.532s.345-.349.28-.685-.295-.574-.515-.532-.345.349-.28.685",
    transform: "translate(-83.729 -48.869)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M175.575,97.279c.065.336.295.574.515.532s.345-.349.28-.685-.295-.574-.515-.532-.345.349-.28.685",
    transform: "translate(-87.502 -48.142)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M175.965,96.289l.762-.388s-.292.71-.762.388",
    transform: "translate(-87.705 -47.799)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M173.591,99.467a9.126,9.126,0,0,0,1.61,1.914,1.473,1.473,0,0,1-1.155.455Z",
    transform: "translate(-86.522 -49.577)",
    fill: "#ff5652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M168.839,106.55a.1.1,0,0,0,.119.156,2.716,2.716,0,0,1,2.45-.009.1.1,0,1,0,.1-.172,2.866,2.866,0,0,0-2.641,0,.094.094,0,0,0-.032.024",
    transform: "translate(-84.141 -52.936)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M165.108,95.985a.2.2,0,0,0,.068-.078,1.6,1.6,0,0,1,1.137-.9.2.2,0,0,0-.048-.4,1.993,1.993,0,0,0-1.45,1.124.2.2,0,0,0,.292.255",
    transform: "translate(-82.138 -47.153)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M175.886,91.61a.169.169,0,0,0,.024-.029.2.2,0,0,0-.052-.279,2,2,0,0,0-1.813-.271.2.2,0,0,0,.152.372,1.594,1.594,0,0,1,1.434.231.2.2,0,0,0,.256-.023",
    transform: "translate(-86.686 -45.318)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M168.4,97.745l.762-.388s-.292.71-.762.388",
    transform: "translate(-83.932 -48.525)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M113.38,207.432a2.669,2.669,0,0,1-2.668-2.642c-.069-7.126,2.3-13.139,6.863-17.391,5.612-5.235,14.368-7.667,24.659-6.854,7.218.572,11.847-1.188,17.2-3.226.881-.335,1.771-.673,2.684-1.006a2.668,2.668,0,0,1,1.826,5.015c-.888.324-1.755.654-2.613.979-5.46,2.077-11.1,4.221-19.522,3.558-8.781-.7-16.094,1.235-20.6,5.436-3.482,3.249-5.221,7.77-5.166,13.437a2.669,2.669,0,0,1-2.642,2.694Z",
    transform: "translate(-55.181 -87.798)",
    fill: "#dd0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M208.46,179.181l10.741-3.934-6.9-18.85-10.741,3.934a3.6,3.6,0,0,0-2.139,4.611l4.432,12.1a3.6,3.6,0,0,0,4.611,2.139",
    transform: "translate(-99.285 -77.952)",
    fill: "#f199a8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160780",
    "data-name": "Group 160780",
    transform: "translate(99.914 78.445)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160779",
    "data-name": "Group 160779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160778",
    "data-name": "Group 160778",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M208.46,179.181l10.741-3.934-6.9-18.85-10.741,3.934a3.6,3.6,0,0,0-2.139,4.611l4.432,12.1a3.6,3.6,0,0,0,4.611,2.139",
    transform: "translate(-199.199 -156.397)",
    fill: "#f199a8"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M215.746,158.148l4.791-1.755,6.905,18.852L222.651,177a2.875,2.875,0,0,1-.716-1.1l-6.024-16.447a2.877,2.877,0,0,1-.165-1.3",
    transform: "translate(-107.525 -77.95)",
    fill: "#eb667c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2106",
    "data-name": "Rectangle 2106",
    width: 0.502,
    height: 3.338,
    transform: "translate(123.296 83.325) rotate(-20.115)",
    fill: "#dd0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M234.3,154.455l-1.694-4.626a4.094,4.094,0,0,0-3.834-2.673,4.044,4.044,0,0,0-1.395.248l-3.052,1.119-.172-.471,3.052-1.118a4.547,4.547,0,0,1,1.567-.278,4.6,4.6,0,0,1,4.305,3l1.694,4.625Z",
    transform: "translate(-111.723 -73.096)",
    fill: "#dd0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M228.781,174.046l4.468-1.637a2.829,2.829,0,0,0,1.679-3.619L228.78,152a2.829,2.829,0,0,0-3.619-1.679l-4.468,1.637a2.83,2.83,0,0,0-1.679,3.619l6.148,16.786a2.829,2.829,0,0,0,3.619,1.679",
    transform: "translate(-109.076 -74.84)",
    fill: "#dd0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M231.232,161.935a1.5,1.5,0,1,1-1.931-.9,1.5,1.5,0,0,1,1.931.9",
    transform: "translate(-113.797 -80.22)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M238.7,182.323a1.5,1.5,0,1,1-1.931-.9,1.5,1.5,0,0,1,1.931.9",
    transform: "translate(-117.519 -90.382)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M142.1,154.183l-.043-.043c-.784-.783-1.612-1.635-2.356-2.5-.76-.861-1.482-1.744-2.146-2.648a24.688,24.688,0,0,1-1.785-2.764,14.57,14.57,0,0,1-.964-2.143c.3-1,.619-1.992,1-2.969.438-1.157.931-2.3,1.467-3.418s1.108-2.228,1.723-3.308q.456-.813.943-1.6l.494-.774c.157-.251.341-.524.472-.717l.056-.083a2.507,2.507,0,0,0-4.094-2.894c-.252.343-.441.611-.644.911s-.383.59-.572.885q-.552.89-1.063,1.8a39.808,39.808,0,0,0-1.839,3.73c-.284.632-.53,1.284-.788,1.927-.229.658-.478,1.306-.677,1.976a37.179,37.179,0,0,0-1.051,4.057l-.026.119a2,2,0,0,0,.08,1.1,16.362,16.362,0,0,0,1.919,3.63,23.944,23.944,0,0,0,2.479,2.992,30.786,30.786,0,0,0,2.8,2.535,29.46,29.46,0,0,0,3.091,2.159,1.248,1.248,0,0,0,1.519-1.956",
    transform: "translate(-64.879 -63.45)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M157.672,183.275l-.063-.13a3.125,3.125,0,0,0-2.193-1.7l-3.809-.771-1.858.928c.2,2.083,3.179,3.331,3.179,3.331l.847.969a1.748,1.748,0,0,0,2.327.275l1.008-.714a1.749,1.749,0,0,0,.563-2.185",
    transform: "translate(-74.638 -90.05)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M142.785,123.386c-2.111.969-4.362,4.316-4.362,4.316l4.534,8.454s5.135-5.917,4.7-8.875c-.369-2.512-2.184-5.129-4.873-3.895",
    transform: "translate(-68.993 -61.341)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160783",
    "data-name": "Group 160783",
    transform: "translate(69.43 61.729)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160782",
    "data-name": "Group 160782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160781",
    "data-name": "Group 160781",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M142.785,123.386c-2.111.969-4.362,4.316-4.362,4.316l4.534,8.454s5.135-5.917,4.7-8.875c-.369-2.512-2.184-5.129-4.873-3.895",
    transform: "translate(-138.423 -123.07)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160808",
    "data-name": "Group 160808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160807",
    "data-name": "Group 160807",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M378.181,221.117c-4.419,0-8.764-.91-10.868-3.658-9.975-13.024-9.884-39.274-9.8-64.66.047-13.664,1.127-26.572-.39-36.6a17.342,17.342,0,0,0-7.166-12.068c-4.673-3.088-11.1-1.43-13.84-.721a2.669,2.669,0,0,1-1.334-5.168c3.43-.886,11.465-2.96,18.117,1.436,4.486,2.964,8.368,8.253,9.5,15.722,1.58,10.433.5,23.54.451,37.416-.084,24.492-.171,49.817,8.7,61.4.715.934,3.519,1.77,8.15,1.531.41-.021.813-.049,1.207-.083a2.669,2.669,0,0,1,2.4-3.835c5.831,0,8.9.49,9.494,3.169.17.767.26,2.693-2.56,4.006a33.791,33.791,0,0,1-12.06,2.114",
    transform: "translate(-165.867 -48.334)",
    fill: "#dd0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M301.462,337.563l-5.443-2.139,2.871-9.436,5.444,2.139Z",
    transform: "translate(-147.543 -162.48)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M288.541,343.575l6.131,2.409a.371.371,0,0,1,.231.4l-.6,3.819a.624.624,0,0,1-.855.476c-1.539-.636-3.948-1.687-5.9-2.454-1.2-.472-3.483-1.225-5.142-1.876-1.623-.637-1.231-2.377-.494-2.259a9.446,9.446,0,0,0,5.892-.526,1.03,1.03,0,0,1,.737.009",
    transform: "translate(-140.193 -171.209)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160788",
    "data-name": "Group 160788",
    transform: "translate(149.868 163.51)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160787",
    "data-name": "Group 160787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160786",
    "data-name": "Group 160786",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M305.717,328.132l-5.446-2.14-1.477,4.865L304.24,333Z",
    transform: "translate(-298.794 -325.992)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M311.745,184.653s-4.924,24.348-6.809,36.354c-2.114,13.458-7.708,38.04-7.708,38.04l7.238,2.844s10.337-25.166,11.778-37.357c4.337-9.9,12.966-39.057,12.966-39.057Z",
    transform: "translate(-148.145 -92.035)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M296.534,330.114l7.943,3.121,1.358-2.406-8.882-3.681Z",
    transform: "translate(-147.799 -163.058)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M291.906,342.587a1.289,1.289,0,0,1-.682-.5.606.606,0,0,1,0-.571.319.319,0,0,1,.264-.2c.528-.053,1.492,1.231,1.6,1.378a.1.1,0,0,1-.095.16,5,5,0,0,1-1.089-.264m-.266-1.049a.287.287,0,0,0-.131-.024c-.03,0-.069.016-.1.087a.41.41,0,0,0-.006.39,2.047,2.047,0,0,0,1.375.622,4.06,4.06,0,0,0-1.136-1.075",
    transform: "translate(-145.117 -170.118)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M294.153,342.241a.108.108,0,0,1-.04-.029c-.322-.383-.772-1.56-.516-1.967a.328.328,0,0,1,.395-.128.552.552,0,0,1,.352.277,3.028,3.028,0,0,1-.058,1.783.1.1,0,0,1-.076.069.1.1,0,0,1-.057,0m-.168-1.916-.043-.014c-.127-.033-.16.019-.174.041-.151.24.095,1.093.38,1.561a2.423,2.423,0,0,0,.02-1.422.356.356,0,0,0-.183-.167",
    transform: "translate(-146.298 -169.514)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160791",
    "data-name": "Group 160791",
    transform: "translate(170.422 107.376)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160790",
    "data-name": "Group 160790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160789",
    "data-name": "Group 160789",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M343.568,214.076c-2.727,3.384-3.8,12-3.794,19.181,1.841-5.07,3.949-11.512,5.806-17.361Z",
    transform: "translate(-339.773 -214.076)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M365.583,341.106h-5.848l-.778-9.832H364.8Z",
    transform: "translate(-178.912 -165.114)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M353.529,349.9h6.587a.37.37,0,0,1,.362.29l.839,3.774a.625.625,0,0,1-.622.755c-1.665-.029-4.292-.126-6.389-.126-1.291,0-3.69.134-5.472.134-1.743,0-2.015-1.762-1.286-1.922a9.444,9.444,0,0,0,5.292-2.644,1.031,1.031,0,0,1,.689-.261",
    transform: "translate(-173.038 -174.397)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160794",
    "data-name": "Group 160794",
    transform: "translate(180.043 166.162)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160793",
    "data-name": "Group 160793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160792",
    "data-name": "Group 160792",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M364.8,331.279h-5.851l.4,5.068h5.851Z",
    transform: "translate(-358.954 -331.279)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M340.291,185.271s3.24,27.128,3.922,36.895c.949,13.59,4.614,40.426,4.614,40.426H356.6s.834-27.407-.574-39.6c1.937-10.635,1.325-36.906,1.325-36.906Z",
    transform: "translate(-169.609 -92.343)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M356,336.866h8.534l.384-2.736-9.613-.178Z",
    transform: "translate(-177.094 -166.45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M356.009,350.157a1.289,1.289,0,0,1-.818-.216.606.606,0,0,1-.208-.532.32.32,0,0,1,.172-.284c.471-.242,1.839.6,1.994.7a.1.1,0,0,1-.03.184,5.021,5.021,0,0,1-1.111.152m-.631-.879a.284.284,0,0,0-.13.026c-.027.014-.059.04-.064.118a.411.411,0,0,0,.136.365,2.047,2.047,0,0,0,1.508.076,4.069,4.069,0,0,0-1.45-.585",
    transform: "translate(-176.931 -173.99)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M357.952,349.018a.1.1,0,0,1-.048-.012c-.439-.239-1.289-1.169-1.2-1.643a.329.329,0,0,1,.32-.264.555.555,0,0,1,.429.13c.493.4.594,1.628.6,1.68a.1.1,0,0,1-.045.092.1.1,0,0,1-.055.017m-.857-1.721-.046,0c-.13.016-.142.076-.147.1-.053.279.488.983.925,1.315a2.422,2.422,0,0,0-.5-1.331.357.357,0,0,0-.231-.088",
    transform: "translate(-177.786 -173)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M321.613,103.639h-.021l-4.686-.061c-1.572-.011-3.138-.046-4.686-.073-.471-.01-.933-.031-1.4-.049l.075-.083c.33-.35.66-.712,1-1.057.169-.179.338-.355.509-.526s.355-.363.464-.5l.427-.539a2.594,2.594,0,0,0-2.719-4.1l-.929.251c-.289.087-.574.179-.857.274-.561.2-1.117.411-1.663.65a24.63,24.63,0,0,0-3.185,1.7,22.744,22.744,0,0,0-2.983,2.269,19.536,19.536,0,0,0-2.662,2.966,4.627,4.627,0,0,0-.5.861,4.394,4.394,0,0,0,2.269,5.785l.455.2a19.619,19.619,0,0,0,3.191,1.057c.952.244,1.857.4,2.742.552s1.758.273,2.618.38,1.718.182,2.568.254c1.7.153,3.385.226,5.065.277s3.327.049,5.071-.03a5.228,5.228,0,0,0-.168-10.45",
    transform: "translate(-148.248 -48.126)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M337.38,119.2c-4.046,4.618-13.787,2.891-13.787,2.891l.534-11.5a50.584,50.584,0,0,1,10.165-1.174c5.715-.013,6.328,6.083,3.088,9.781",
    transform: "translate(-161.286 -54.538)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M326.818,115.677c-.243,1.853-.479,4.352-.657,7.714-2.112,10.68-2.9,18.25-1.034,23.771,1.473,1.821,20.691,1.469,24.147,1.122,1.993-4.966,2.215-19.22,2.449-31.2a6.909,6.909,0,0,0-5.74-6.934,46.537,46.537,0,0,0-13.1-.442,6.9,6.9,0,0,0-6.062,5.972",
    transform: "translate(-161.526 -54.544)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160797",
    "data-name": "Group 160797",
    transform: "translate(183.935 68.422)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160796",
    "data-name": "Group 160796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160795",
    "data-name": "Group 160795",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M366.714,136.414c.064,3.656,2.711,9.489,5.689,12.446.182-3.085.3-6.431.39-9.8Z",
    transform: "translate(-366.714 -136.414)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M379.22,131.96l-.169-.4a38.071,38.071,0,0,0-2.455-4.846c-.894-1.5-1.853-2.925-2.855-4.3s-2.054-2.676-3.138-3.952c-.549-.632-1.1-1.264-1.674-1.873l-.87-.915-.939-.931a5.224,5.224,0,0,0-7.561,7.2l.149.165,2.948,3.277c.995,1.115,1.958,2.25,2.91,3.376.462.568.938,1.135,1.373,1.709.463.565.887,1.137,1.319,1.708.62.867,1.221,1.727,1.757,2.576a12.532,12.532,0,0,1-.307,1.27,37.4,37.4,0,0,1-1.268,3.583c-.486,1.238-1.033,2.49-1.586,3.755s-1.147,2.554-1.673,3.807l-.047.11a2.637,2.637,0,0,0,4.212,2.964A41.69,41.69,0,0,0,372.491,147c.987-1.132,1.924-2.312,2.821-3.564.448-.625.871-1.279,1.293-1.952a23.009,23.009,0,0,0,1.2-2.132,20.238,20.238,0,0,0,1.055-2.469,11.293,11.293,0,0,0,.64-3.368,3.726,3.726,0,0,0-.281-1.552",
    transform: "translate(-178.544 -56.438)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M362.681,110.914c6.768,1.154,11.174,10.315,11.174,10.315l-8.155,8.747a67.7,67.7,0,0,1-7.51-9.218c-3.058-4.828-.357-10.671,4.491-9.844",
    transform: "translate(-177.885 -55.243)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M342.3,71.294a6.059,6.059,0,0,1,.575-7.175,2.115,2.115,0,0,1-2.069-.986,12.458,12.458,0,0,1,8.069-2.809c6.074,0,6.527,2.342,6.319,3.943,4.151.265,7.181,11.068-3.348,12.976-6.022-6.364-9.547-5.949-9.547-5.949",
    transform: "translate(-169.866 -30.067)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M368.316,64.749s1.692-1.725-.411-3.814a2.828,2.828,0,0,1,1.977,1.967c.3,1.215-.52,2.188-1.565,1.847",
    transform: "translate(-183.372 -30.371)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M354.47,91.388c-.161,3.323-.458,7.106.1,9.763-.862,1.356-3.068,2.921-7.026,3.272-1.408-.8-3.262-2.746-2.616-3.75,1.683-1.079,2.394-4.346,1.911-6.786Z",
    transform: "translate(-171.853 -45.55)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160800",
    "data-name": "Group 160800",
    transform: "translate(174.983 46.466)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160799",
    "data-name": "Group 160799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160798",
    "data-name": "Group 160798",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M354.575,92.639l-5.71,1.87a9.054,9.054,0,0,1,.022,3.152,7.667,7.667,0,0,0,4.957-2.547,3.164,3.164,0,0,0,.732-2.476",
    transform: "translate(-348.865 -92.639)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M354.849,73.671c-1.058,4.079-1.471,6.519-3.968,8.232-3.758,2.576-8.485-.308-8.666-4.621-.164-3.882,1.594-9.9,5.956-10.755a5.747,5.747,0,0,1,6.679,7.144",
    transform: "translate(-170.563 -33.101)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M363.592,69.249c-1.788,1.275-4.011,6.671.525,8.835,4.032-3.558,2.982-8.835-.525-8.835",
    transform: "translate(-180.151 -34.515)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M356.768,66.946c.764-3.554-8.2-5.387-11.038-1.241-.961,2.484,10.494,4.706,11.038,1.241",
    transform: "translate(-172.291 -31.563)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M351.42,88.776h0a8.723,8.723,0,0,0-2.949-.745.1.1,0,0,0-.106.111.138.138,0,0,0,.132.117,8.489,8.489,0,0,1,2.83.714.118.118,0,0,0,.155-.054.108.108,0,0,0-.059-.142",
    transform: "translate(-173.632 -43.876)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M365.185,86.708a4.008,4.008,0,0,1-2.788,1.258c-1.4.033-1.762-1.306-1.083-2.451.61-1.03,2.077-2.29,3.347-1.777a1.8,1.8,0,0,1,.524,2.969",
    transform: "translate(-179.921 -41.678)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M353.674,80.064c-.066.336-.3.574-.517.531s-.345-.35-.279-.686.3-.574.516-.531.345.35.279.686",
    transform: "translate(-175.874 -39.561)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M346.1,78.587c-.066.336-.3.574-.517.531s-.345-.35-.279-.686.3-.574.516-.531.345.35.28.686",
    transform: "translate(-172.099 -38.825)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M347.1,80.077a12.261,12.261,0,0,1-2.166,2.562,1.922,1.922,0,0,0,1.609.539Z",
    transform: "translate(-171.922 -39.912)",
    fill: "#ed847e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M353.241,76.853a.2.2,0,0,1,.2.062,1.6,1.6,0,0,0,1.335.574.2.2,0,0,1,.228.17.2.2,0,0,1-.17.228,1.992,1.992,0,0,1-1.694-.706.2.2,0,0,1,.018-.284.2.2,0,0,1,.082-.044",
    transform: "translate(-175.988 -38.302)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M344.42,73.836a.2.2,0,0,1-.1-.069.2.2,0,0,1,.034-.282,1.99,1.99,0,0,1,1.794-.389.2.2,0,0,1,.126.255.2.2,0,0,1-.254.127,1.6,1.6,0,0,0-1.417.324.2.2,0,0,1-.179.036",
    transform: "translate(-171.594 -36.397)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M372.569,180.581l-4.31-.031,2.227,4.945s3.675-.788,3.475-2.783Z",
    transform: "translate(-183.549 -89.99)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M363.712,183.943l.708,1.394a1.674,1.674,0,0,0,2.112.8l1.6-.638-2.227-4.945-1.712,1.3a1.673,1.673,0,0,0-.478,2.089",
    transform: "translate(-181.192 -89.991)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M308.813,136.457a2.668,2.668,0,0,1-1.913-4.528c1.919-1.975,3.648-3.5,5.173-4.848,3.682-3.25,4.949-4.5,4.829-6.948a24.489,24.489,0,0,0-.953-4.427c-1.1-4.035-2.34-8.607-.213-12.27a8.884,8.884,0,0,1,5.773-4.015,2.669,2.669,0,1,1,1.335,5.168c-1.888.487-2.343,1.271-2.493,1.528-1.007,1.734-.034,5.313.747,8.189a27.524,27.524,0,0,1,1.134,5.565c.253,5.139-2.783,7.819-6.627,11.211-1.454,1.284-3.1,2.737-4.878,4.565a2.659,2.659,0,0,1-1.914.809",
    transform: "translate(-152.589 -49.512)",
    fill: "#dd0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M322.295,95.886l4.177-1.066-.974,5.336s-3.757.117-4.042-1.866Z",
    transform: "translate(-160.221 -47.26)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M333.414,97.65l-.322,1.391a1.752,1.752,0,0,1-1.945,1.34l-1.634-.225.973-5.335,1.916.828a1.751,1.751,0,0,1,1.012,2",
    transform: "translate(-164.237 -47.261)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M274.859,172l-.117-.117a1.3,1.3,0,0,1,0-1.835l14.795-14.8a1.3,1.3,0,0,1,1.835,0l.117.117a1.3,1.3,0,0,1,0,1.835l-14.8,14.8a1.3,1.3,0,0,1-1.835,0",
    transform: "translate(-136.749 -77.192)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M290.212,187.352l-.117-.117a1.3,1.3,0,0,1,0-1.835l14.795-14.8a1.3,1.3,0,0,1,1.835,0l.117.117a1.3,1.3,0,0,1,0,1.835l-14.8,14.8a1.3,1.3,0,0,1-1.835,0",
    transform: "translate(-144.401 -84.844)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M309.007,159.169l-10.425,10.425-14.195-14.2,10.425-10.425a3.605,3.605,0,0,1,5.083,0l9.111,9.112a3.605,3.605,0,0,1,0,5.083",
    transform: "translate(-141.746 -71.736)",
    fill: "#f199a8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160803",
    "data-name": "Group 160803",
    transform: "translate(142.642 72.19)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160802",
    "data-name": "Group 160802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160801",
    "data-name": "Group 160801",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M309.007,159.169l-10.425,10.425-14.195-14.2,10.425-10.425a3.605,3.605,0,0,1,5.083,0l9.111,9.112a3.605,3.605,0,0,1,0,5.083",
    transform: "translate(-284.388 -143.926)",
    fill: "#f199a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160806",
    "data-name": "Group 160806",
    transform: "translate(142.64 80.055)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160805",
    "data-name": "Group 160805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160804",
    "data-name": "Group 160804",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M287.992,159.606l-3.608,3.608,14.2,14.2,3.608-3.608a2.874,2.874,0,0,0-.7-1.113L289.1,160.3a2.88,2.88,0,0,0-1.113-.7",
    transform: "translate(-284.384 -159.606)",
    fill: "#eb667c"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M298.725,178.979l-.255.255a2.829,2.829,0,0,1-3.99,0l-12.64-12.64a2.829,2.829,0,0,1,0-3.99l.255-.256a2.83,2.83,0,0,1,3.99,0l12.64,12.64a2.829,2.829,0,0,1,0,3.99",
    transform: "translate(-140.065 -80.508)",
    fill: "#dd0025"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatDisconnectedIcon);
export default __webpack_public_path__ + "static/media/live-chat-disconnected-icon.3bad2638d28aca0b31b6671840150913.svg";
export { ForwardRef as ReactComponent };